import { User } from '../models';

export interface ConfirmEmailVerificationConfig {
  isSent: boolean;
  hasError: boolean;
  errorMessage: string;
};

export interface AuthStateErrorResponse {
  a: any;
  code: string;
  message: string;
}

export interface AuthStateModel {
  token: string | null;
  accessToken: string | null;
  loaded: boolean;
  user: User | null;
  confirmEmailVerification: ConfirmEmailVerificationConfig;
  error?: AuthStateErrorResponse;
}
